function ChevronRight(props) {
  return (
    <svg
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.84031 4.99996L0.65958 1.95232C0.299953 1.60774 0.299953 1.03294 0.65958 0.688356C0.998114 0.363986 1.53212 0.363986 1.87066 0.688355L5.73799 4.39387C5.90575 4.55461 6 4.77263 6 4.99996C6 5.22729 5.90575 5.44531 5.73799 5.60605L1.87066 9.31156C1.53212 9.63593 0.998115 9.63593 0.65958 9.31156C0.299953 8.96698 0.299954 8.39218 0.659581 8.0476L3.84031 4.99996Z"
      fill="#111111"
    />
  </svg>
  )
}

export default ChevronRight
